import { defineComponent as _defineComponent } from 'vue'
import {computed} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateCommon',
  props: {
  date: {
    type: [Date, Number],
    required: true
  },
  showTime: {
    type: Boolean,
    default: true,
    required: false
  },
  showTooltip: {
    type: Boolean,
    required: false,
    default: false
  }
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const trueDate = computed(()=> {
  let date = new Date(props.date);
  if(!props.showTime) {
    return date.toLocaleDateString('fr-CH');
  }
  return date.toLocaleDateString('fr-CH') + ', ' + date.toLocaleTimeString();
});

const retrieveConvertedTime = () => {
  let date = new Date(props.date);
  return date.toLocaleDateString('fr-CH') + ', ' + date.toLocaleTimeString();
};

const __returned__ = { props, trueDate, retrieveConvertedTime }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})